import axios from "axios";
import { createContext, useState } from "react";

import { useNavigate } from "react-router-dom";
 
const OrgContext = createContext();
 
export const OrgContextProvider = ({ children }) => {
  const [organisation, setOrganisation] = useState(() => {
    if (localStorage.getItem("orgs")) {
      let orgs = JSON.parse(localStorage.getItem("orgs"));
      return orgs.organisation
    }
    return null;
  });

  const changeOrg = async (org) => {
    try {
        setOrganisation(org);
        localStorage.setItem("orgs",  JSON.stringify({organisation: org}));
    } catch (error) {
        throw("Can't not change organisation");
    }
  }

  const removeOrg = async () => {
    try {
        setOrganisation(null);
        localStorage.removeItem("orgs");
    } catch (error) {
        throw("Can't not remove organisation");
    }
  }


  return (
    <OrgContext.Provider value={{ organisation, changeOrg, removeOrg }}>
      {children}
    </OrgContext.Provider>
  );
};
 
export default OrgContext;